
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';

function Intro() {
  return (
<div className='container featurette-divider' id="intro" >
<div className="row featurette m-auto">
<div className="col-md-5">
  <h2 className="featurette-heading py-3" >ごあいさつ<span className="text-muted">greeting</span></h2>
  <p className="lead py-3">高本電業株式会社のホームページをご覧いただきありがとう御座います。</p>
  <p className="lead py-3">高本電業株式会社は、電力会社異動作業業務委託、電力会社の電気工事調整委託等を行っております。</p>
</div>
<div className="col-md-7 intro_bg">

</div>


</div>
</div>
  );
}




export default Intro;